export default "__VITE_ASSET__BEAt6uA6__"